<template>
  <div class="main">
    <div class="container">
      <div class="xmgj">
        <div class="xmgjInfo">
          <div class="name">小马之家</div>
          <div class="introduce">让工作更高效</div>
          <div class="line"></div>
          <el-button type="primary" round @click="downLoadApp('xmzj')">立即下载</el-button>
        </div>
        <div class="xmgjBg">
            <img src="../assets/imgs/workBg.png" class="imgStyle" />
            <div class="copyright">
                <div>Copyright © 2021 小马国炬 版权所有</div>
            </div>
        </div>
      </div>
     

      <div class="wxtip" id="JweixinTip">
        <div class="flex">
          <span class="close" @click="closetip()">×</span>
          <span class="wxtip-icon img">
            <img src="../assets/tip.png" alt="" />
          </span>
        </div>
        <p class="wxtip-txt">点击右上角<br />选择在浏览器中打开</p>
      </div>
      <!-- <div class="load" style="display:none">
                <p></p>
            </div> -->
      <!-- <div class="mask" style="display: none;">
                <div class="alert">
                    <div class="descript"></div>
                    <div class="confirm">
                        <button class="confirmBtn" type="button" onclick="closemask()">确定</button>
                    </div>
                </div>
            </div> -->
    </div>
    <DownLoadTip></DownLoadTip>
  </div>
</template>
<script src="./config/env.js"></script>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script src="http://m-cdn.saclub.com.cn/app/2.4/js/jquery-1.11.3.min.js"></script>
<script src="https://code.jquery.com/jquery-3.1.1.min.js"></script>
<script type="text/javascript">
import { API_URL } from "@/fetch/fetch";
import Pad from "./pad";
import DownLoadTip from '../components/DownLoadTip.vue'
import Util from '../utils/index.js'
export default {
  components: { Pad,DownLoadTip },
  data() {
    return {};
  },
  mounted() {
    this.isWeiXin();
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    // this.closetip();
  },
  methods: {
    handleScroll() {
      console.log(11111111);
    },
    isWeiXin() {
      //是否是微信打开，并且提示引导
      var ua = window.navigator.userAgent.toLowerCase();
      //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        $("#JweixinTip").attr("style", "display:none;");
        return true;
      } else {
        $("#JweixinTip").attr("style", "display:none;");
        return false;
      }
    },
    closetip() {
      //隐藏div
      $("#JweixinTip").attr("style", "display:none;"); //隐藏div
    },
    downLoadApp(name) {
      let flag = Util.judgeFlag()
      this.$store.commit('CHANGE_DOWNLOADNAME',name)
      this.$store.commit('CHANGE_TYPE',3)
      if(flag){
          this.$store.commit('CHANGE_SHOW',name)
          return
      }
      Util.downLoadApp()
    },
    closemask() {
      $(".mask").css("display", "none");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  width: 100vw;
  background-color: #f9fbff;
  // overflow: scroll;
}
.flexR {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -moz-box;
  display: flex;

  -webkit-box-orient: horizontal;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;

  -webkit-box-pack: space-between;
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;

  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.flex1 {
  -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-flex: 1; /* OLD - Firefox 19- */
  width: 20%; /* For old syntax, otherwise collapses. */
  -webkit-flex: 1; /* Chrome */
  -ms-flex: 1; /* IE 10 */
  flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}

.container {
  // 小马国炬板块
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    position: relative;
    position: absolute;
    background-color: #f9fbff;
    // padding-top: 96px;
    // top: 96px;
    .xmgjBg {
      width: 100%;
      position: absolute;
      bottom: 0;
    //   z-index: 1;
    }
    .imgStyle{
        width: 100%;
    }
    .xmgjInfo {
      width: 100%;
      position: absolute;
      top: 168px;
      text-align: center;
      z-index: 2;
      .line {
        width: 80px;
        height: 8px;
        background: linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: auto;
        margin-bottom: 36px;
      }
      .name {
        color: #262626;
        font-size: 90px;
        font-weight: bold;
        height: 78px;
        line-height: 78px;
        margin-bottom: 24px;
      }
      .introduce {
        font-size: 36px;
        font-weight: 400;
        color: #939599;
        margin-bottom: 36px;
      }
      ::v-deep .el-button--primary {
        width: 275px;
        height: 96px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 40px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  @media screen and (min-width: 768px) {
    width: 100%;
    height: 100%;
    position: relative;
    position: absolute;
    background-color: #f9fbff;
    padding-top: 76px;
    .xmgjBg {
      width: 100%;
    }
    .imgStyle{
        width: 100%;
    }
    .xmgjInfo {
      width: 100%;
      position: absolute;
      top: 380px;
      text-align: center;
      .line {
        width: 80px;
        height: 16px;
        background: linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: auto;
        margin-bottom: 36px;
      }
      .name {
        color: #262626;
        font-size: 96px;
        font-weight: bold;
        height: 120px;
        line-height: 120px;
        margin-bottom: 8px;
      }
      .introduce {
        font-size: 50px;
        font-weight: 400;
        color: #939599;
        margin-bottom: 64px;
      }
      ::v-deep .el-button--primary {
        width: 400px;
        height: 100px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 40px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  // 更多应用
  .more {
    margin-top: 56px;
    padding: 0 40px;
    margin-bottom: 21px;

    .line {
      background: linear-gradient(135deg, #d2e0fd 0%, #dce5fa 0%, #b0bad3 100%);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      margin-bottom: 36px;
      @media screen and (max-width: 768px) {
        width: 40px;
        height: 8px;
      }
      @media screen and (min-width: 768px) {
        width: 80px;
        height: 12px;
      }
    }
    .name {
      font-size: 56px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: bold;
      color: #262626;
    }
    .moreImg {
      width: 382px;
      height: 52px;
    }
  }
  // 所有应用
  .appCell {
    position: relative;
    background-color: #f2f2f2;
    padding-right: 32px;
    .cellInfo {
      position: absolute;
      top: 100px;
      text-align: center;
      .name {
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 700;
        color: #262626;
      }
      .introduce {
        font-weight: 400;
        color: #939599;
      }
    }

    @media screen and (max-width: 768px) {
      .leftInfo {
        margin-left: 102px;
      }
      .rightInfo {
        right: 0;
        padding-right: 102px;
      }
      .appLogo {
        width: 104px;
        height: 104px;
        margin-bottom: 16px;
      }
      .appBg {
        width: 100%;
        margin-bottom: 21px;
      }
      .name {
        font-size: 32px;
        margin-bottom: 4px;
      }
      .introduce {
        font-size: 24px;
        margin-bottom: 24px;
      }
      ::v-deep .el-button--primary {
        width: 192px;
        height: 60px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 24px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
    @media screen and (min-width: 768px) {
      .leftInfo {
        width: 50%;
        height: 94%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        // display: -webkit-box;
        // display: -webkit-flex;
        // display: -ms-flexbox;
        // display: -moz-box;
        // display: flex;

        // -webkit-box-orient: vertical;
        // -webkit-flex-direction: column;
        // -moz-flex-direction: column;
        // -ms-flex-direction: column;
        // -o-flex-direction: column;
        // flex-direction: column;

        // -webkit-box-pack: center;
        // -webkit-justify-content: center;
        // -moz-justify-content: center;
        // -ms-justify-content: center;
        // -o-justify-content: center;
        // justify-content: center;

        // -webkit-box-align: center;
        // -webkit-align-items: center;
        // -moz-align-items: center;
        // -ms-align-items: center;
        // -o-align-items: center;
        // align-items: center;
      }
      .rightInfo {
        width: 50%;
        height: 94%;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .appLogo {
        width: 200px;
        height: 200px;
        margin-bottom: 16px;
      }
      .appBg {
        width: 100%;
      }
      .name {
        font-size: 64px;
        margin-bottom: 8px;
        margin-top: 20px;
        color: red;
      }
      .introduce {
        font-size: 44px;
        margin-bottom: 44px;
      }
      ::v-deep .el-button--primary {
        width: 50%;
        height: 100px;
        background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
        opacity: 1;
      }
      ::v-deep .el-button {
        font-size: 36px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .leftBox {
    padding-left: 32px;
    padding-right: 0;
  }

  .copyright {
    background-color: #F9FBFF;
    padding: 24px 0 24px 0;
    text-align: center;
    font-size: 24px;
    color: #999999;
  }
}

::v-deep .el-button.is-round {
  border-radius: 87px 87px 87px 87px;
}

.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  display: none;
}

#JweixinTip .flex {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  top: 40px;
  left: 40px;
  width: 96%;
  margin: 0 auto;
  color: white;
}
.wxtip-icon {
  width: 52px;
  height: 67px;
  display: block;
  position: absolute;
  right: 20px;
}
.wxtip-icon img {
  width: 100%;
  height: 80px;
  right: 50px;
  position: absolute;
  top: 15px;
}
.wxtip-txt {
  margin-top: 80px;
  color: #fff;
  font-size: 26px;
}
.close {
  font-size: 46px;
}
.active {
  font-weight: 700;
  color: #333;
}
.noactive {
  font-weight: 400;
  color: #666;
}
</style>
